import { useNavigate } from "react-router-dom";
import { EyeIcon, PlusIcon } from "@heroicons/react/24/solid";
import { useAppSelector } from "../../../app/hooks";
import { UserRole } from "../../../app/userSlice";

interface NoDataCardProps {
	message: string;
	isLessonCard?: boolean;
	isWritingCard?: boolean;
}

export default function NoDataCard(props: NoDataCardProps) {
	const { role } = useAppSelector((state) => state.user);
	const navigate = useNavigate();

	return (
		<div className="border border-gray-200 bg-white mb-1 shadow-sm sm:rounded-md text-base text-center text-gray-700 p-6">
			<p>{props.message}</p>
			{props.isWritingCard &&
				(role === UserRole.Writer ? (
					<NoDataActionBody
						message="Click on the button below to view available prompts to start writing to."
						buttonId="start-writing-button"
						buttonLabel="View Practice Prompts"
						onClick={() => {
							navigate("/writing", {
								state: {
									section: "PracticePrompts",
								},
							});
						}}
					/>
				) : (
					<NoDataActionBody
						message="Click on the button below to create a new prompt for your students to write to."
						buttonId="create-prompt-button"
						buttonLabel="Create Prompt"
						onClick={() => {
							navigate("/writing/prompt");
						}}
					/>
				))}
			{props.isLessonCard &&
				(role === UserRole.Writer ? (
					<NoDataActionBody
						message="Click on the button below to choose a lesson to start working on."
						buttonId="choose-lesson-button"
						buttonLabel="View Lesson Library"
						onClick={() => {
							navigate("/lessons", {
								state: {
									section: "LessonLibrary",
								},
							});
						}}
					/>
				) : (
					<NoDataActionBody
						message="Click on the button below to assign a lesson now."
						buttonId="assign-lesson-button"
						buttonLabel="Assign Lesson"
						onClick={() => {
							navigate("/lessons", { state: { openDialog: true } });
						}}
					/>
				))}
		</div>
	);
}

interface NoDataActionBodyProps {
	message: string;
	buttonId: string;
	buttonLabel: string;
	onClick: () => void;
}

function NoDataActionBody(props: NoDataActionBodyProps) {
	const { role } = useAppSelector((state) => state.user);

	return (
		<div>
			<h3 className="pt-1 pb-4 text-base">{props.message}</h3>
			<button id={props.buttonId} className="btn btn-primary" onClick={props.onClick}>
				<span className="flex items-center">
					{role === UserRole.Writer ? (
						<EyeIcon className="size-4 mr-2" />
					) : (
						<PlusIcon className="size-4 mr-2" />
					)}
					{props.buttonLabel}
				</span>
			</button>
		</div>
	);
}
